export default "__VITE_ASSET__BD_kJWRH__"